export enum Quadrant {
  Null = -1,
  CENTER,
  NE,
  SE,
  SW,
  NW,
}
